import { Megaphone } from "lucide-react";
import { Button } from "./button";
import React, { useEffect, useState } from "react";

export function FestivalAds({ T }) {
  const campaigns = [
    {
      title: "Navratri‑velsignelser",
      body: "Spesial for kjærlighet og karriere • Festivaltilbud",
      cta: "Utforsk",
      gradient: "from-fuchsia-200 via-pink-200 to-purple-200",
    },
    {
      title: "Diwali – Uke for velstand",
      body: "Tiltrekk overflod: Lakshmi‑fokusert rådgivning og renselser",
      cta: "Utforsk",
      gradient: "from-amber-200 via-yellow-200 to-orange-200",
    },
    {
      title: "Nymåneseremoni",
      body: "Gruppemeditasjon + private veiledningspakker",
      cta: "Bli med",
      gradient: "from-indigo-200 via-sky-200 to-cyan-200",
    },
  ];
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    if (paused) return;
    const id = setInterval(() => setI((x) => (x + 1) % campaigns.length), 5000);
    return () => clearInterval(id);
  }, [paused]);
  const c = campaigns[i];

  return (
    <section
      className="py-12 px-4 max-w-6xl mx-auto"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <h2 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
        <Megaphone className="w-6 h-6 text-purple-600" /> {T.festivalTitle}
      </h2>
      <div className={`rounded-3xl p-8 bg-gradient-to-r ${c.gradient} shadow-lg transition-all duration-300`}>
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <p className="uppercase tracking-wide text-xs text-gray-700">Begrenset periode</p>
            <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900">{c.title}</h3>
            <p className="text-gray-800 mt-1">{c.body}</p>
          </div>
          <Button className="bg-purple-700 hover:bg-purple-800 text-white rounded-full px-6 py-3">{c.cta}</Button>
        </div>
      </div>
    </section>
  );
}